// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CalculatorsRouteImport } from './routes/calculators'
import { Route as CitiesWeServeRouteImport } from './routes/cities-we-serve'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as LinksRouteImport } from './routes/links'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TaxCenterRouteImport } from './routes/tax-center'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAccountingRouteImport } from './routes/services.accounting'
import { Route as ServicesAuditingRouteImport } from './routes/services.auditing'
import { Route as ServicesBookkeepingRouteImport } from './routes/services.bookkeeping'
import { Route as ServicesBusinessFormationRouteImport } from './routes/services.business-formation'
import { Route as ServicesPartTimeCfoRouteImport } from './routes/services.part-time-cfo'
import { Route as ServicesPayrollRouteImport } from './routes/services.payroll'
import { Route as ServicesSmallBusinessRouteImport } from './routes/services.small-business'
import { Route as ServicesTaxPlanningRouteImport } from './routes/services.tax-planning'
import { Route as ServicesTaxPreparationRouteImport } from './routes/services.tax-preparation'
import { Route as ServicesTaxationRouteImport } from './routes/services.taxation'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CalculatorsRoute = CalculatorsRouteImport.update({
            id: '/calculators',path: '/calculators',getParentRoute: () => rootRouteImport
          })
const CitiesWeServeRoute = CitiesWeServeRouteImport.update({
            id: '/cities-we-serve',path: '/cities-we-serve',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TaxCenterRoute = TaxCenterRouteImport.update({
            id: '/tax-center',path: '/tax-center',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesAccountingRoute = ServicesAccountingRouteImport.update({
            id: '/accounting',path: '/accounting',getParentRoute: () => ServicesRoute
          })
const ServicesAuditingRoute = ServicesAuditingRouteImport.update({
            id: '/auditing',path: '/auditing',getParentRoute: () => ServicesRoute
          })
const ServicesBookkeepingRoute = ServicesBookkeepingRouteImport.update({
            id: '/bookkeeping',path: '/bookkeeping',getParentRoute: () => ServicesRoute
          })
const ServicesBusinessFormationRoute = ServicesBusinessFormationRouteImport.update({
            id: '/business-formation',path: '/business-formation',getParentRoute: () => ServicesRoute
          })
const ServicesPartTimeCfoRoute = ServicesPartTimeCfoRouteImport.update({
            id: '/part-time-cfo',path: '/part-time-cfo',getParentRoute: () => ServicesRoute
          })
const ServicesPayrollRoute = ServicesPayrollRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => ServicesRoute
          })
const ServicesSmallBusinessRoute = ServicesSmallBusinessRouteImport.update({
            id: '/small-business',path: '/small-business',getParentRoute: () => ServicesRoute
          })
const ServicesTaxPlanningRoute = ServicesTaxPlanningRouteImport.update({
            id: '/tax-planning',path: '/tax-planning',getParentRoute: () => ServicesRoute
          })
const ServicesTaxPreparationRoute = ServicesTaxPreparationRouteImport.update({
            id: '/tax-preparation',path: '/tax-preparation',getParentRoute: () => ServicesRoute
          })
const ServicesTaxationRoute = ServicesTaxationRouteImport.update({
            id: '/taxation',path: '/taxation',getParentRoute: () => ServicesRoute
          })





const ServicesRouteChildren = {
  ServicesAccountingRoute: ServicesAccountingRoute,ServicesAuditingRoute: ServicesAuditingRoute,ServicesBookkeepingRoute: ServicesBookkeepingRoute,ServicesBusinessFormationRoute: ServicesBusinessFormationRoute,ServicesPartTimeCfoRoute: ServicesPartTimeCfoRoute,ServicesPayrollRoute: ServicesPayrollRoute,ServicesSmallBusinessRoute: ServicesSmallBusinessRoute,ServicesTaxPlanningRoute: ServicesTaxPlanningRoute,ServicesTaxPreparationRoute: ServicesTaxPreparationRoute,ServicesTaxationRoute: ServicesTaxationRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CalculatorsRoute: CalculatorsRoute,CitiesWeServeRoute: CitiesWeServeRoute,ContactRoute: ContactRoute,DisclaimerRoute: DisclaimerRoute,FaqRoute: FaqRoute,GalleryRoute: GalleryRoute,LinksRoute: LinksRoute,PrivacyRoute: PrivacyRoute,ResourcesRoute: ResourcesRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRouteWithChildren,TaxCenterRoute: TaxCenterRoute,TermsRoute: TermsRoute,AdminSplatRoute: AdminSplatRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)